import React, { useState } from "react";
import { HiHeart, HiChevronLeft, HiChevronRight } from "react-icons/hi";
import pic1 from "../../assets/images/successStories/story 1.png";
import pic2 from "../../assets/images/successStories/story 2.png";
import pic3 from "../../assets/images/successStories/story 3.png";

const successStoriesData = [
  {
    img: pic1,
    title: "Tushar",
    partner: "Reshma",
    story: `Happy to announce that my son Tushar Dayanand Prabhu got engaged to
    Reshma Shanbhag on Sunday 26th, December. Thank you admin for your
    kind support, both are from the same group.`,
  },
  {
    img: pic2,
    title: "Sanjana",
    partner: "Rahul",
    story: `Our son Rahul being engaged. We are very much thankful for Smt.
    Jyostna Pai & team.`,
  },
  {
    img: pic3,
    title: "Keerthi",
    partner: "Sushant",
    story: `Sir, thank you for your services provided by you. My daughter
    Keerthi Vishnu Mahale married Sushant (Nagesh) Jaivant Balgi Bhatkal
    today, both were members of the platform. Regards, Vishnu Vaman
    Mahale.`,
  },
];

const SuccessStories = () => {
  const [activeStep, setActiveStep] = useState(0);
  const maxSteps = successStoriesData.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => (prevActiveStep + 1) % maxSteps);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => (prevActiveStep - 1 + maxSteps) % maxSteps);
  };

  const handleStepClick = (step) => {
    setActiveStep(step);
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-cover bg-center" style={{backgroundImage: "url('https://images.unsplash.com/photo-1561433881-71f27412406f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80')"}}>
      <h1 className="text-4xl font-bold text-white mb-8">Success Stories</h1>

      <div className="max-w-lg w-full bg-white rounded-lg shadow-lg overflow-hidden p-2">
        <div className="relative h-96 w-full rounded-md">
          <img
            src={successStoriesData[activeStep].img}
            alt={`${successStoriesData[activeStep].title} & ${successStoriesData[activeStep].partner}`}
            className="w-full h-full object-cover object-top rounded-md"
          />
        </div>

        <div className="p-6">
          <h2 className="text-2xl font-semibold mb-2 flex items-center justify-center text-center">
            {successStoriesData[activeStep].title} <HiHeart className="mx-2 text-red-500" size={24} /> {successStoriesData[activeStep].partner}
          </h2>
          <p className="text-gray-600 text-sm text-center">{successStoriesData[activeStep].story}</p>
        </div>

        <div className="flex justify-center space-x-2 my-4">
          {successStoriesData.map((_, index) => (
            <button
              key={index}
              onClick={() => handleStepClick(index)}
              className={`w-3 h-3 rounded-full ${
                index === activeStep ? "bg-blue-500" : "bg-gray-300"
              }`}
            ></button>
          ))}
        </div>

        <div className="flex justify-between p-4 bg-gray-100">
          <button
            onClick={handleBack}
            className="flex items-center bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition duration-300"
          >
            <HiChevronLeft className="mr-1" size={20} />
            Back
          </button>
          <button
            onClick={handleNext}
            className="flex items-center bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition duration-300"
          >
            Next
            <HiChevronRight className="ml-1" size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessStories;